<p>{{ text | translate:translateParams }}</p>
